@if (parameters?.length) {
  <app-open-parameters-atom
    [items]="parameters"
    [iconBackgroundColor]="iconBackgroundColor"
    [iconColor]="iconColor"
    [textColor]="textColor"
    (click)="openParametersModal()"
  ></app-open-parameters-atom>
}
